module.exports = __webpack_public_path__ + "static/media/employee-appreciation-2.c3920fb9.jpg";